export default "__VITE_ASSET__BgjMsbfK__"